module.exports = __webpack_public_path__ + "img/virusFiestas.0d90df3a.jpg";